import { Button } from '@heidi/design-system/button';
import { TypographyH5, TypographyP2 } from '@heidi/design-system/typography';
import { Blocks } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

type TemplatesEmptyProps = {
  isAuthenticated: boolean;
  resetFilters: () => void;
};

const TemplatesEmpty = ({ isAuthenticated, resetFilters }: TemplatesEmptyProps) => {
  return (
    <div className="flex w-full flex-col items-center gap-6">
      <div
        className={`rounded-lg p-8 ${isAuthenticated ? 'bg-background-secondary' : 'bg-surface-page'}`}
      >
        <Blocks size={48} className="text-text-disabled" />
      </div>
      <div>
        <TypographyH5 className="text-center text-text-secondary">
          <FormattedMessage
            id="SEar699Wd9"
            defaultMessage="Sorry, we couldn't find any matching templates"
          />
        </TypographyH5>
        <TypographyP2 className="text-center text-text-secondary">
          <FormattedMessage
            id="t8LeSyLJLo"
            defaultMessage="Try searching for something else or adjusting any filters you have applied."
          />
        </TypographyP2>
      </div>
      <Button
        size="lg"
        disableAutomaticSvgSizing
        variant="secondary"
        onClick={resetFilters}
      >
        <FormattedMessage id="F4gyn3vRX6" defaultMessage="Clear filters" />
      </Button>
    </div>
  );
};

export default TemplatesEmpty;
